import { render } from "./CreateBtnAndModal.vue?vue&type=template&id=2876c992"
import script from "./CreateBtnAndModal.vue?vue&type=script&lang=js"
export * from "./CreateBtnAndModal.vue?vue&type=script&lang=js"

import "./CreateBtnAndModal.vue?vue&type=style&index=0&id=2876c992&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__